export const fund = {
  totalWrap: {
    background: 'var(--default-white)',
    borderRadius: '8px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'var(--box-shadow--2)',
    margin: '0 24px 20px',

    '@media (max-width: 1199.98px)': {
      padding: '16px',
      margin: '0 0 20px 0',
    },

    '@media (max-width: 639.98px)': {
      padding: '12px',
    },
  },

  wrapper: {
    '@media (max-width: 639.98px)': {
      padding: '16px 20px 0',
    },
  },

  totalLabel: {
    color: 'var(--neutral-300)',
    textAlign: 'center',
    marginBottom: '5px',

    '@media (max-width: 639.98px)': {
      fontSize: '14px',
      lineHeight: '14px',
      marginBottom: '0px',
    },
  },

  totalValue: {
    color: 'var(--primary-700)',
    textAlign: 'center',

    '@media (max-width: 639.98px)': {
      fontSize: '20px',
    },
  },

  fundList: {
    flex: 1,
    alignContent: 'flex-start',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    paddingBottom: '24px',
    marginRight: '24px',
    marginLeft: '24px',

    '@media (max-width: 1199.98px)': {
      paddingBottom: '80px',
      margin: '0px',
    },

    '@media (max-width: 639.98px)': {
      gap: '12px',
    },
  },

  popup: {
    position: 'sticky',
    bottom: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    background: 'var(--default-white)',
    boxShadow: 'var(--box-shadow--2)',
  },

  drawer: {
    '@media (min-width: 1200px)': {
      // display: 'none',
      maxWidth: '1200px',
    },
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '972px',
      padding: '48px 200px',
      width: '100%',

      '@media (max-width: 1199.98px)': {
        padding: '48px 120px',
      },

      '@media (max-width: 639.98px)': {
        padding: '0',
      },
    },
  },

  moneyIconWrapper: {
    display: 'flex',
    alignItems: 'center',

    svg: {
      path: {
        fill: 'var(--default-white)',
      },
    },
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
	position: 'relative',

    '@media (max-width: 1199.98px)': {
      minHeight: 'calc(100vh - 104px)',
      height: '100%',
    },

    '@media (min-width: 1200px)': {
      minHeight: 'calc(100vh - 128px)',
      overflow: 'auto',
      position: 'relative',
      //   padding: '24px',
      backgroundColor: 'var(--default-white)',
      boxShadow: 'var(--box-shadow--2)',
      paddingTop: ' 24px',
    },
  },
};
